import React , { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { fetchEstadosLiquidaciones } from '../../../actions/LiquidacionesActions';
import { fetchResultadosLiquidaciones } from '../../../actions/LiquidacionesActions';
import Select from 'react-select';
import { customStyleFilter, DropDownArrow } from '../../../template/CustomStyle';
import { toast } from 'react-toastify';
//import {  } from "../../../template/CustomStyle";
import { currencyFormat } from '../../../helper/publicacionHelper';
import { getEstadosLiquidaciones } from '../../../api/axios';
import { getResultadosLiquidaciones } from '../../../api/axios.js';
import { exportToExcel } from '../../../components/General/Excel/ExcelExportHelper';

class ExportarNovedades extends Component {

    constructor(props) {
        super(props);
        this.state = {
            request: null,
            hideSpinner: true,
            estadoCheckbox: false,
            datosExcelFormateados: null,
            comboLiquidacionSeller: { label: "", value: "" },
            comboLiquidacionEstado: { label: "", value: "" },
            fechaDesde: "",
            fechaDesdePredeterminado: "",
            fechaHasta: "",
            fechaHastaPredeterminado: "",
            ordenDeReferencia: ""
        }
    };

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    componentDidMount() {

        let fecha = new Date();
        fecha.setDate(fecha.getDate() - 15);
        let fechaNewQuince = fecha.toISOString().slice(0, 10);
        let fechaActual = new Date();
        fechaActual.setDate(fechaActual.getDate());
        let fechaNewActual = fechaActual.toISOString().slice(0, 10);
        this.setState({
            fechaDesde: fechaNewQuince,
            fechaDesdePredeterminado: fechaNewQuince,
            fechaHasta: fechaNewActual,
            fechaHastaPredeterminado: fechaNewActual
        });

        localStorage.removeItem("ListLiquidacionesSeller");
        localStorage.removeItem("ListLiquidacionesEstado");
        localStorage.removeItem("ListLiquidacionesFechaDesde");
        localStorage.removeItem("ListLiquidacionesFechaHasta");
        localStorage.removeItem("ListLiquidacionesEliminaNovedad");
        localStorage.removeItem("ListLiquidacionesOrdenDeReferencia");
        localStorage.setItem('ListLiquidacionesEstado', 1);
        this.props.fetchEstadosLiquidaciones();
    }

    onChangePayMount = (event) => {

        let publicacion = "";
        let isMoney = (event.target.name == "id_a_editar_importe") ? true : false;

        if (isMoney) {
            publicacion = currencyFormat(event.target.value);
        } else {
            publicacion = event.target.value;
        }
        if (publicacion == "NaN") {
            publicacion = "";
        }

        this.setState({ inputValue: publicacion });
    }

    busquedaParaDescargarExcel = () => {

        if (this.state.estadoCheckbox === true) {

            this.setState({hideSpinner: false});
            const listaOrdenesExcel = [];
    
            if (this.state.fechaDesde === "") {
                toast.error("Debe seleccionar una fecha inicial");
                this.setState({ hideSpinner: true });
                return;
            }
            if (this.state.fechaHasta === "") {
                toast.error("Debe seleccionar una fecha final");
                this.setState({ hideSpinner: true });
                return;
            }
          
            // Mantengo localStorage por compatibilidad con otras pantallas, pero el export usa request explícito.
            localStorage.setItem('ListLiquidacionesFechaDesde', this.state.fechaDesde);
            localStorage.setItem('ListLiquidacionesFechaHasta', this.state.fechaHasta);

            const request = {
                fechaDesde: this.state.fechaDesde,
                fechaHasta: this.state.fechaHasta,
                buscaTodo: 1,
                idSeller: 0,
                idEstado: 0,
                ordenDeReferencia: 0
            };

            getResultadosLiquidaciones(request).then(res => {
    
                var objeto = res['novedades'];
            
                for (var j in objeto) {
    
                    let cargaNovedadesExcel = {
                        seller: objeto[j]['seller'],
                        fecha: objeto[j]['fechaNovedad'],
                        ordenDeReferencia: objeto[j]['ordenDeReferencia'],
                        concepto: objeto[j]['detalleTipoNovedad'],
                        estado: objeto[j]['detalleEstadoNovedad'],
                        comentarios: objeto[j]['comentarios'],
                        importe: objeto[j]['importe']
                    };
                    listaOrdenesExcel.push(cargaNovedadesExcel);
                }
    
                this.setState({
                    datosExcelFormateados: listaOrdenesExcel,
                    hideSpinner: true
                })
    
                var link = null;
                link = document.getElementById('btnDescargaExcel');
                link.click();
            });
        } 
    }

    selectSearchHandlerLiquidacionesSeller = (options) => {

        let valor = { label: options.label, value: options.value.toString() };
        this.setState({
            comboLiquidacionSeller: valor
        })
        localStorage.setItem('ListLiquidacionesSeller', options.value);

    }

    selectSearchHandlerLiquidacionesEstado = (options) => {

        let valor = { label: options.label, value: options.value.toString() };
        this.setState({
            comboLiquidacionEstado: valor
        })
        localStorage.setItem('ListLiquidacionesEstado', options.value);
    }

    mapSellers = () => {
        // Igual que en Órdenes/Publicaciones: cargar desplegable general y permitir búsqueda
        this.props.fetchSellersFilter({
            Descripcion: "",
            Page: 1,
            PageSize: 100
        });
    }

    onSelectSearchInputSellers = (descripcion, action) => {
        if (action.action === 'input-change') {
            this.props.fetchSellersFilter({
                Descripcion: descripcion,
                Page: 1,
                PageSize: 100
            });
        }
    }

    mapEstados = () => {
        getEstadosLiquidaciones().then(res => {
            const raw =
                Array.isArray(res?.listadoEstadosNovedades) ? res.listadoEstadosNovedades :
                    Array.isArray(res?.estados) ? res.estados : [];
            const listaEstados = raw.map((tipo) => ({
                label: tipo.descripcion ?? tipo.Descripcion ?? "",
                value: (tipo.idEstado ?? tipo.IdEstado ?? "").toString()
            }));
            this.setState({
                listaTipoEstados: listaEstados
            })
        })
    }


    render() {

        const listaSellers = Array.isArray(this.props.filteredSellers)
            ? this.props.filteredSellers.map(s => ({ label: s.label, value: s.value.toString() }))
            : [];

        let selectListaSellers = 
        <div style={{
            position: "relative",
            left: "-15px",
            paddingBottom: "10px"
        }} className="col-lg-12">
            <p className="font-bold">Seller</p>
            <Select
                name="ListLiquidacionesSeller"
                id="ListLiquidacionesSeller"
                value={this.state.comboLiquidacionSeller}
                options={listaSellers}
                onChange={this.selectSearchHandlerLiquidacionesSeller}
                onMenuOpen={this.mapSellers}
                onInputChange={this.onSelectSearchInputSellers}
                styles={customStyleFilter}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>

        // INICIO - COMBO DE LISTA DE ESTADOS DE LIQUIDACIONES
        let tipoValEstados = null;
        let listaTipoEstados = [];
        if (this.props.lista_estados_liquidaciones != undefined) {
            this.props.lista_estados_liquidaciones.map((tipo, index) => {
                if (tipo.idEstado == this.props.lista_estados_liquidaciones.idEstado) {
                    tipoValEstados = { label: tipo.descripcion, value: tipo.idEstado.toString() }
                }
                listaTipoEstados.push({ label: tipo.descripcion, value: tipo.idEstado.toString() })
            })
        }

        let selectListaEstados = 
        <div style={{
            position: "relative",
            left: "-15px",
            paddingBottom: "10px"
        }} className="col-lg-12">
            <p className="font-bold">Estados</p>
            <Select
                name="ListLiquidacionesIdestado"
                id="ListLiquidacionesIdestado"
                value={this.state.comboLiquidacionEstado}
                options={listaTipoEstados.length ? listaTipoEstados : (this.state.listaTipoEstados || [])}
                onChange={this.selectSearchHandlerLiquidacionesEstado}
                onMenuOpen={this.mapEstados}
                styles={customStyleFilter}
                components={{ DropdownIndicator: () => DropDownArrow }}
            />
        </div>
        // FIN - COMBO DE LISTA DE ESTADOS DE LIQUIDACIONES

        let sizeArray = JSON.stringify(this.state.datosExcelFormateados);

        return (

            <div className="row justify-content-between page-titles">

                <div className="col-7">
                    <h4 className="text-themecolor color-rojo-megatone mx-1">Novedades</h4>
                </div>

                <div className="col-2 button-group align-self-center text-right d-none d-md-block">
                    <Spinner hidden={this.state.hideSpinner || sizeArray == "[]"} style={{ position: "relative", top: "5px", right: "0px", padding: "0px", margin: "0px" }} animation="border" variant="secondary" size="sm-centrado" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                </div>

                <div className="col-2 button-group text-end">

                    <button type="button" onClick={this.busquedaParaDescargarExcel} className="btn btn-sm btn-green" disabled={!this.state.estadoCheckbox}>Descargar Excel</button>

                    <button 
                        id="btnDescargaExcel" 
                        type="button" 
                        hidden={true} 
                        className="btn btn-sm"
                        onClick={() => exportToExcel(this.state.datosExcelFormateados, 'Novedades', 'Novedades')}
                    >
                        Descargar Excel
                    </button>

                </div>

                <div className="card card-body filter-card m-3">
                    <div className="row form-material">

                        <div className="col-md-2">
                            <p className="font-bold">Desde</p>
                            <input 
                                type="date" 
                                name="ListLiquidacionesFechaDesde" 
                                id="ListLiquidacionesFechaDesde" 
                                className="form-control" 
                                value={this.state.fechaDesde}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="col-md-2">
                            <p className="font-bold">Hasta</p>
                            <input 
                                type="date" 
                                name="ListLiquidacionesFechaHasta" 
                                id="ListLiquidacionesFechaHasta" 
                                className="form-control" 
                                value={this.state.fechaHasta}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="col-3">
                            {selectListaSellers}
                        </div>

                        <div className="col-3">
                            {selectListaEstados}
                        </div>

                        <div className="col-md-2">
                            <p className="font-bold">Orden De Referencia</p>
                            <input 
                                type="number" 
                                name="ordenDeReferencia"
                                id="ListLiquidacionesOrdenDeReferencia" 
                                className="form-control"
                                value={this.state.ordenDeReferencia}
                                onChange={this.myChangeHandler}
                            />
                        </div>
                    </div>

                    <div className="ibox-content float-e-margins">
                        <input 
                            type="checkbox" 
                            onChange={(e) => this.setState({estadoCheckbox: e.target.checked})} 
                            id="BuscaTodo"
                        /> 
                        <label for="BuscaTodo">
                            Todas las novedades de todos los sellers en el rango de tiempo
                        </label>
                    </div>

                </div>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    filteredSellers: state.sellers.filteredSellers,
    tipoUsuario: state.general.tipoUsuario,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones,
    lista_resultado_liquidaciones: state.liquidaciones.lista_resultados_liquidaciones
});

export default connect(mapStateToProps, { 
    fetchSellersFilter,
    fetchEstadosLiquidaciones, 
    fetchResultadosLiquidaciones 
}) (ExportarNovedades);